import React, { useState, useEffect } from "react";
import ArrowRightAltIcon from "@material-ui/icons/ArrowRightAlt";
import Box from "@material-ui/core/Box";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Button from "@material-ui/core/Button";
import Hidden from "@material-ui/core/Hidden";
import Accordion from "@material-ui/core/Accordion";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import Upload from "./Upload";
import {
  StyledControlPanel,
  StyledCircleButton,
  StyledSeparator,
  StyledColor,
  StyledControlButtons,
  StyledControlButton,
  StyledColorCheckIcon,
  StyledControlsOverlayCover,
} from "./common.styles";
import colors from "../../constants/colors";

const sides = ["Front", "Right", "Back", "Left"];

const Controls = ({
  onSideSelection,
  selectedFocusCoordinates,
  onColorSelection,
  updateLogoTexture,
  updateWrapTexture,
  onPreviewModeSet,
  forceSelectedSide,
  selectedLogoImages,
  initializing,
  wrapImage,
  hidden,
}) => {
  const [value, setValue] = useState(0);
  const [colorMap, setColorMap] = useState({});
  const [showControls, setShowControls] = useState(false);

  useEffect(() => {
    if (forceSelectedSide >= 0) {
      setValue(forceSelectedSide);
    }
  }, [forceSelectedSide]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    onSideSelection(newValue);
  };

  const onSelect = (index, coords, file) => {
    updateLogoTexture(index, coords, file);
  };

  const onSelectWrap = (file) => {
    updateWrapTexture(file);
  };

  const handleColorSelection = (color) => {
    const colorSelection = {
      ...colorMap,
      [selectedFocusCoordinates.element]: color,
    };

    setColorMap(colorSelection);
    onColorSelection(color);
  };

  const handlePreviewModeSelection = () => {
    handleChange(null, 0);
    onPreviewModeSet(true);
  };

  return (
    <Box display={hidden ? "none" : "block"}>
      <StyledControlsOverlayCover className={showControls ? "opened" : ""} />
      <StyledControlPanel className={showControls ? "opened" : ""}>
        <Box p={1}>
          <Box display="flex" flexDirection="row" alignItems="center">
            <Typography variant="h3">Customize Your Robot</Typography>
            <Box flex="1" />
            <Hidden lgUp>
              <StyledCircleButton
                onClick={() => setShowControls(!showControls)}
              >
                {!showControls ? (
                  <KeyboardArrowUpIcon />
                ) : (
                  <KeyboardArrowDownIcon />
                )}
              </StyledCircleButton>
            </Hidden>
          </Box>
          <Box mt={1}>
            <Tabs
              value={value}
              indicatorColor="primary"
              onChange={handleChange}
              variant="fullWidth"
              disabled={initializing}
            >
              {sides.map((side) => (
                <Tab label={side} disabled={initializing} />
              ))}
            </Tabs>
          </Box>
        </Box>
        <Box mt={0.5} />
        <StyledSeparator />
        <Box mt={1} />
        <Box pl={1} pr={1} overflow={"auto"} flex="1">
          {selectedFocusCoordinates.logos.map((logo) => (
            <>
              <Upload
                key={logo.name}
                label={`${logo.name} Image`}
                onSelect={(img) => onSelect(logo.name, logo.coords, img)}
                preselected={
                  selectedLogoImages[logo.name] &&
                  selectedLogoImages[logo.name].file
                }
              />
              <Box mt={1} />
            </>
          ))}
          {(selectedFocusCoordinates.canEdit ||
            selectedFocusCoordinates.predefindedColors) && (
            <Accordion disabled={initializing}>
              <AccordionSummary
                expandIcon={
                  <StyledCircleButton>
                    <img src={require("../../assets/add.png")} />
                  </StyledCircleButton>
                }
              >
                <Typography variant="subtitle2">Select Color</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Box
                  display="flex"
                  flexDirection="row"
                  flexWrap="wrap"
                  width="100%"
                >
                  {(selectedFocusCoordinates.predefindedColors || colors).map(
                    (color, index) => (
                      <Box flexBasis="14.28%" mb={0.5} position="relative">
                        <StyledColor
                          color={color.value}
                          onClick={() => handleColorSelection(color.value)}
                          border={color.border}
                        />
                        {colorMap[selectedFocusCoordinates.element] ===
                          color.value && <StyledColorCheckIcon />}
                      </Box>
                    )
                  )}
                </Box>
              </AccordionDetails>
            </Accordion>
          )}
          <Box mt={1} />
          {!selectedFocusCoordinates.enforceHideWrap && (
            <Upload
              label="Wrap"
              onSelect={onSelectWrap}
              preselected={wrapImage}
              tooltipLabel="Full wraps are not available. Think about building a more complex design using a series of smaller stickers."
            />
          )}
        </Box>
        <Box p={1}>
          <Button
            fullWidth
            variant="contained"
            color="primary"
            onClick={() => handlePreviewModeSelection()}
            disabled={initializing}
          >
            Next Step
          </Button>
        </Box>
      </StyledControlPanel>
      <StyledControlButtons>
        <StyledControlButton
          rotate
          onClick={() => {
            !initializing && value > 0
              ? handleChange(null, value - 1)
              : handleChange(null, sides.length - 1);
          }}
        >
          <ArrowRightAltIcon fontSize={"large"} />
        </StyledControlButton>
        <StyledControlButton
          onClick={() => {
            !initializing && value < sides.length - 1
              ? handleChange(null, value + 1)
              : handleChange(null, 0);
          }}
        >
          <ArrowRightAltIcon fontSize={"large"} />
        </StyledControlButton>
      </StyledControlButtons>
    </Box>
  );
};

export default Controls;
